export default __webpack_public_path__ + "static/media/sponsor.551198b8.webp";